export default "__VITE_ASSET__BW6c2Mzv__"